// extracted by mini-css-extract-plugin
export default {"diceWrapper":"diceWrapper-OwMeG4VK","pulsing":"pulsing-cdiDsi2k","pulse":"pulse-kM0XrtoK","dice":"dice-M9xGB5i5","inactive":"inactive-UFjHOdfZ"};